import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';

// Import CSS reset and Global Styles
import { GlobalStyle } from './styles/global-styles';

// import i18n (needs to be bundled ;))
import './i18n';

// import loader
import Loader from './components/Loader';

// import pdfjs and set the worker source
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = './pdf.worker.min.mjs';

const MOUNT_NODE = document.getElementById('root');

ReactDOM.render(
  <React.Fragment>
    <GlobalStyle />
    <Suspense fallback={<Loader />}>
      <App />
    </Suspense>
  </React.Fragment>,
  MOUNT_NODE,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
